import create from "zustand";
import {
  getIsApplicationsActiveReq,
  updateIsApplicationsActiveReq,
  updateAllowDocumentUploadsReq,
} from "@/api/adminApi";

interface GlobalSetting {
  key: string;
  value: boolean;
}

interface ApplicationState {
  isActive: boolean | null;
  allowDocumentUploads: boolean | null;
  fetchIsActive: () => void;
  toggleNewProjectApplication: () => void;
  toggleAllowDocumentUploads: () => void;
}

export const useApplicationStore = create<ApplicationState>(
  (set, getState) => ({
    isActive: null,
    allowDocumentUploads: null,

    fetchIsActive: async () => {
      try {
        const response = await getIsApplicationsActiveReq();
        const settings: GlobalSetting[] = response.data?.globalSetting ?? [];
        const findValue = (key: string) =>
          settings.find((setting) => setting.key === key)?.value ?? null;
        set({
          isActive: findValue("acceptApplications"),
          allowDocumentUploads: findValue("allowDocumentUploads"),
        });
      } catch (e) {
        console.error("Error fetching application state", e);
      }
    },

    toggleNewProjectApplication: async () => {
      try {
        const { isActive } = getState();
        await updateIsApplicationsActiveReq({ value: !isActive });
        set({ isActive: !isActive });
      } catch (e) {
        console.error("Error toggling application state", e);
      }
    },

    toggleAllowDocumentUploads: async () => {
      try {
        const { allowDocumentUploads } = getState();
        await updateAllowDocumentUploadsReq({ value: !allowDocumentUploads });
        set({ allowDocumentUploads: !allowDocumentUploads });
      } catch (e) {
        console.error("Error toggling document upload state", e);
      }
    },
  }),
);
